import * as Yup from "yup";


export function initialValues(session) {
  let state = null;
  if(session?.state === true){
    state = 'ACTIVO';
  }else if(session?.state === false){
    state = 'INACTIVO';
  }else{
    state = '';
  }
  return {
    title: session?.title || "",
    weekId: session?.weekId || "",
    type: session?.type || "",
    state: state || '',
    index: session?.index || 0,
  };
}

export function validationSchema() {
  return Yup.object({
    title: Yup.string().required("El título es obligatorio"),
    weekId: Yup.string().required("La unidad es obligatoria"),
    type: Yup.string().required("El tipo es obligatorio"),
    state: Yup.string().required("El estado es obligatorio"),
    index: Yup.number().required("El índice es obligatorio"),
  });
}
